import { SET_MISSION, RESET  } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    missionId : null, // not realiable at the moment see otuApp.appState.missionId for a reliable value
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('Mission - Reducer')

  switch (action.type) {
    case SET_MISSION:
      state.missionId=action.missionId
      otuApp.appState.missionId = state.missionId // side effect that needs to be cleaned up/ fixed someday

      break;
    case RESET:
      state = initialState()
      break;
  }

  return state

}